// src/components/BookDetailsPage.js
import React from 'react';
import './BookDetailsPage.css'; // We will create this next

const BookDetailsPage = ({ book, onBack }) => {
  return (
    <div className="details-page-container">
      <div className="details-card">
        <button className="details-back-button" onClick={onBack}>&larr; Back to List</button>
        <div className="details-content">
          <div className="details-cover">
            {book.cover_id ? (
              <img 
                src={`https://covers.openlibrary.org/b/id/${book.cover_id}-L.jpg`} 
                alt={`${book.title} cover`}
              />
            ) : (
              <div className="no-cover-details">No Cover</div>
            )}
          </div>
          <div className="details-info">
            <h1>{book.title}</h1>
            <h2>by {book.authors ? book.authors.join(', ') : 'Unknown Author'}</h2>
            <p className="publish-date">First Published: {book.publish_year || 'N/A'}</p>
            <div className="description">
              <h3>Description</h3>
              <p>{book.description || 'No description available for this book.'}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookDetailsPage;